function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

export const state = {
  user: null,
  hasSignedNda: !!getCookie("ndaAccepted")
};

export const mutations = {
  USER_SET(state, user) {
    state.user = user;
    if (!user) {
      eraseCookie("ndaAccepted");
    }
  },
  NDA_SIGNED(state, isSigned) {
    state.hasSignedNda = isSigned;
    if (isSigned) {
      setCookie("ndaAccepted", "true", 1);
    } else {
      eraseCookie("ndaAccepted");
    }
  }
};

export const actions = {
  userSet({ commit }, user) {
    commit("USER_SET", user);
  },
  userSignNda({ commit }, isSigned) {
    commit("NDA_SIGNED", isSigned);
  }
};

export const getters = {
  userIsLoggedIn: state => {
    return !!state.user;
  },
  userHasSignedNda: state => {
    return state.hasSignedNda;
  },
  userName: state => {
    return state.user ? state.user.name : "";
  },
  userIsAdmin: state => {
    return state.user ? state.user.isAdmin : false;
  },
  userIsVerifier: state => {
    return state.user ? state.user.isVerifier : false;
  },
  userIsReadOnly: state => {
    return state.user ? state.user.isReadOnly : false;
  },
  userMemberSociety: state => {
    return state.user ? state.user.memberSociety : "invalid";
  }
};
